import { IconProps } from ".";

export const TickIcon: React.FC<IconProps> = (props) => {
  return (
    <svg viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M5.11139 11.2597L5.11114 11.2595C4.9822 11.1305 4.80734 11.0581 4.625 11.0581C4.44266 11.0581 4.2678 11.1305 4.13886 11.2595C4.00993 11.3884 3.9375 11.5633 3.9375 11.7456C3.9375 11.7566 3.93776 11.7676 3.93829 11.7786C3.9465 11.9493 4.01801 12.1109 4.13886 12.2317L4.13912 12.232L8.95136 17.0442C9.21985 17.3127 9.65515 17.3127 9.92364 17.0442L19.5486 7.41924C19.6776 7.29031 19.75 7.11544 19.75 6.93311C19.75 6.75077 19.6776 6.5759 19.5486 6.44697C19.4197 6.31804 19.2448 6.24561 19.0625 6.24561C18.8802 6.24561 18.7053 6.31804 18.5764 6.44697L9.4375 15.5858L5.11139 11.2597Z"
        fill="currentColor"
      />
    </svg>
  );
};
